import { useCallback } from "react";

import CopyFieldDropdownMenuItem from "components/CopyField/DropdownMenuItem";
import DropdownMenuEllipsis, {
  DropdownMenuEllipsisProps,
} from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";

import { VcsAgentPoolView } from "../types";
import { showVcsAgentPoolDeleteConfirmation } from "./VcsAgentPoolDeleteConfirmationModal";
import { showVcsAgentPoolDetailsDrawer } from "./VcsAgentPoolDetailsDrawer";
import { showVcsAgentPoolResetConfirmation } from "./VcsAgentPoolResetConfirmationModal";

type VcsAgentPoolActionsProps = {
  vcsAgentPool: VcsAgentPoolView;
  dotsSize?: DropdownMenuEllipsisProps["dotsSize"];
  onDeleteCallback?: () => void;
};

const VcsAgentPoolActions = ({
  vcsAgentPool,
  dotsSize = "small",
  onDeleteCallback,
}: VcsAgentPoolActionsProps) => {
  const handleReset = useCallback(() => {
    showVcsAgentPoolResetConfirmation({
      vcsAgentPool,
      refetchQueriesOnRefresh: ["GetVCSAgentPools"],
    });
  }, [vcsAgentPool]);

  const handleDelete = useCallback(() => {
    showVcsAgentPoolDeleteConfirmation({
      vcsAgentPool,
      refetchQueriesOnDelete: ["GetVCSAgentPools"],
      onDeleteSuccess: onDeleteCallback,
    });
  }, [vcsAgentPool, onDeleteCallback]);

  const handleSeeDetails = useCallback(() => {
    showVcsAgentPoolDetailsDrawer({ id: vcsAgentPool.id, vcsAgentPool });
  }, [vcsAgentPool]);
  return (
    <DropdownMenuEllipsis tooltip="VCS agent pool actions" dotsSize={dotsSize}>
      <CopyFieldDropdownMenuItem title="Copy ID" value={vcsAgentPool.id} />

      <DropdownMenuItem onAction={handleSeeDetails}>See details</DropdownMenuItem>

      <DropdownMenuItem onAction={handleReset}>Reset</DropdownMenuItem>

      <DropdownMenuItem onAction={handleDelete} danger>
        Delete
      </DropdownMenuItem>
    </DropdownMenuEllipsis>
  );
};

export default VcsAgentPoolActions;
